<vc-chart-wrapper
    class="vc-column-chart-wrapper"
    [contentHeight]="contentHeight"
    [loading]="loading"
    [title]="title"
    [formContainer]="formContainer">
    <highcharts-chart
        [class.no-title]="true"
        [options]="options"
        [style.height]="height"
        style="width: 100%; display: block"
        (chartInstance)="onChartInstance($event)">
    </highcharts-chart>
</vc-chart-wrapper>
